import DataStore from "../DataStore";
import {makeEl} from "../../common/Utils";
import {ISns} from "../../interface/IFooter";

export default class SnsList{
    private ds : DataStore;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        if(this.ds.config.snsList.length> 0){
            this.templ(_wrapper);
        }
    }

    templ(_parent : HTMLElement){
        const tmpl = makeEl('div', _parent, {class: 'footer-sns'});
        const ul = makeEl('ul', tmpl, {class: 'footer-sns-list'})

        this.ds.config.snsList.map(it => this.liTempl(ul, it));
    }

    liTempl(_parent: HTMLUListElement, _data: ISns){
        const li = makeEl('li', _parent, {class: 'footer-sns-item footer-sns-item-'+ _data.name.toLowerCase()});
        makeEl('a', li, {href: _data.link, target: '_blank'});
    }
}